import styled from "@emotion/styled";
import { ellipsis } from "polished";
import { FC } from "react";

import { Avatar } from "@livechat/design-system-react-components";

const Container = styled.div`
  overflow: hidden;
  padding: 0 10px 10px 0;
  box-sizing: border-box;
  display: flex;
`;

const TeamName = styled.span`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
  display: inline-block;
  font-size: 15px;
  line-height: 20px;
  padding-left: 10px;
  vertical-align: middle;
  flex: 0 1 auto;
  ${ellipsis()};
`;

interface IProps {
  id: string;
  name: string;
}

export const TeamBadge: FC<IProps> = ({ name }) => (
  <Container>
    <Avatar type="text" text={name} shape="rounded-square" size="xxsmall" css={{ minWidth: "20px" }} />
    <TeamName>{name}</TeamName>
  </Container>
);
